import { Meeting } from '@consigli/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MeetingDetail } from './components/meeting-detail';
import { RecentMeetings } from './recent-meeting-secretary';

export const MeetingSecretaryMeetings = () => {
  const { t } = useTranslation();
  const [selectedMeeting, setSelectedMeeting] = useState<Meeting | null>(null);

  const handleMeetingSelect = (meeting: Meeting) => {
    setSelectedMeeting(meeting);
  };

  const handleBackToList = () => {
    setSelectedMeeting(null);
  };

  return (
    <div className="flex-1 overflow-auto bg-background p-12">
      {selectedMeeting ? (
        <div>
          <button
            onClick={handleBackToList}
            className="mb-6 flex items-center text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            <span className="mr-2">←</span>
            {t('meeting-secretary.meetings.back-to-meetings')}
          </button>
          <MeetingDetail meeting={selectedMeeting} />
        </div>
      ) : (
        <>
          <div className="mb-8">
            <h1 className="text-3xl font-semibold">{t('meeting-secretary.meetings.title')}</h1>
            <p className="text-gray-600 mt-2">{t('meeting-secretary.meetings.description')}</p>
          </div>
          <RecentMeetings onMeetingSelect={handleMeetingSelect} />
        </>
      )}
    </div>
  );
};
